import { useGate } from 'statsig-react';
import { useChannelsEnabled } from '@components/Channels/helpers';
import { useAuth } from '@context/auth/base';
import { useBackendUserPersistedData } from '@hooks/useBackendUserPersistedData';
import { FEATURE_GATES } from '@utils/constants';

export const useHasBanner = () => {
  const { isAuthenticatedWithAPI, isConnectingAPIUser } = useAuth();
  const { value: pointsEnabled } = useGate(FEATURE_GATES.SOCIALS_POINTS);

  const { enabled: channelsEnabled } = useChannelsEnabled();

  const {
    hasDismissedNewLeaderboardFeatureBanner,
    hasDismissedNewRewardsFeatureBanner,
    loading,
    hasDismissedNewChannelsFeatureBanner,
  } = useBackendUserPersistedData();

  const hasNewRewardsBanner =
    !isAuthenticatedWithAPI ||
    (isAuthenticatedWithAPI && hasDismissedNewRewardsFeatureBanner.type === 'not-dismissed');

  const hasNewLeaderboardBanner =
    !isAuthenticatedWithAPI ||
    (isAuthenticatedWithAPI && hasDismissedNewLeaderboardFeatureBanner.type === 'not-dismissed');

  const hasNewChannelsBanner =
    !isAuthenticatedWithAPI ||
    (isAuthenticatedWithAPI && hasDismissedNewChannelsFeatureBanner.type === 'not-dismissed');

  const hasBanner = channelsEnabled
    ? hasNewChannelsBanner
    : pointsEnabled
    ? hasNewLeaderboardBanner
    : hasNewRewardsBanner;

  const isLoading = isConnectingAPIUser || loading;

  return isLoading ? false : hasBanner;
};
